import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	useAsSubOption: ForNodeType<boolean>;

	isNextMorning: ForNodeType<boolean>;
	onSetViewModel: (
		values: {
			key: "isNextMorning";
			value: ForNodeType<boolean>;
		}[],
	) => void;
};

export const useIsNextMorning = ({ useAsSubOption, isNextMorning, onSetViewModel }: Props) => {
	const isEdited = isNextMorning.isEdited;
	const hasError = Boolean(isNextMorning.error);

	const onSetIsNextMorning = (value: boolean) => {
		onSetViewModel([
			{
				key: "isNextMorning",
				value: {
					isEdited: true,
					value,
				},
			},
		]);
	};

	return {
		useAsSubOption,

		isNextMorning,
		onSetIsNextMorning,

		isEdited,
		hasError,
	};
};
